import React, { useEffect } from "react";
import {
  FaCheckCircle,
  FaTimesCircle,
  FaExclamationCircle,
} from "react-icons/fa";

// Generate slots based on hours
const generateTimeSlotsForDay = (startHour = 9, endHour = 18) => {
  const timeIncrement = 30;
  const slots = [];

  const start = new Date();
  start.setHours(startHour, 0, 0, 0);
  const end = new Date();
  end.setHours(endHour, 0, 0, 0);

  while (start < end) {
    const slotStart = new Date(start);
    const slotEnd = new Date(start);
    slotEnd.setMinutes(slotStart.getMinutes() + timeIncrement);

    slots.push({
      start: slotStart.toLocaleTimeString([], {
        hour: "2-digit",
        minute: "2-digit",
      }),
      end: slotEnd.toLocaleTimeString([], {
        hour: "2-digit",
        minute: "2-digit",
      }),
      // selected: false,
      // status: "unavailable",
      selected: true,
      status: "available",
    });

    start.setMinutes(start.getMinutes() + timeIncrement);
  }

  return slots;
};

export default function TimeSlotSelector({
  selectedDays,
  setSelectedDays,
  timeSlots,
  setTimeSlots,
}) {
  const daysOfWeek = [
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday",
    "Sunday",
  ];

  console.log({ timeSlots });

  useEffect(() => {
    const newTimeSlots = [...timeSlots];
    selectedDays.forEach((dayIndex) => {
      if (!newTimeSlots.find((t) => t.dayIndex === dayIndex)) {
        newTimeSlots.push({
          day: daysOfWeek[dayIndex],
          dayIndex,
          startHour: 9,
          endHour: 18,
          breaks: [],
          slots: generateTimeSlotsForDay(9, 18),
        });
      }
    });

    const filtered = newTimeSlots.filter((t) =>
      selectedDays.includes(t.dayIndex)
    );
    setTimeSlots(filtered);
  }, [selectedDays]);

  const toggleDay = (index) => {
    setSelectedDays((prev) =>
      prev.includes(index) ? prev.filter((i) => i !== index) : [...prev, index]
    );
  };

  const toggleSlot = (dayIndex, slotIndex) => {
    const updated = [...timeSlots];
    const daySlot = updated.find((d) => d.dayIndex === dayIndex);
    if (daySlot) {
      const selected = !daySlot.slots[slotIndex].selected;
      daySlot.slots[slotIndex].selected = selected;
      daySlot.slots[slotIndex].status = selected ? "available" : "unavailable";
      setTimeSlots(updated);
    }
  };

  const getHourFromSlot = (timeStr) => {
    if (!timeStr) return "09:00";
    const [time, modifier] = timeStr.split(" ");
    let [hours, minutes] = time.split(":");
    hours = parseInt(hours, 10);
    if (modifier === "PM" && hours !== 12) hours += 12;
    if (modifier === "AM" && hours === 12) hours = 0;
    return `${hours.toString().padStart(2, "0")}:${minutes}`;
  };

  const updateWorkingHour = (dayIndex, field, value) => {
    const updated = [...timeSlots];
    const daySlot = updated.find((d) => d.dayIndex === dayIndex);
    if (daySlot) {
      daySlot[field] = parseInt(value);
      daySlot.slots = generateTimeSlotsForDay(
        daySlot.startHour,
        daySlot.endHour
      );
      setTimeSlots(updated);
    }
  };

  const addBreak = (dayIndex) => {
    const updated = [...timeSlots];
    const daySlot = updated.find((d) => d.dayIndex === dayIndex);
    if (daySlot) {
      daySlot.breaks.push({ label: "Lunch", start: "12:00", end: "13:00" });
      setTimeSlots(updated);
    }
  };

  const updateBreakLabel = (dayIndex, bIndex, value) => {
    const updated = [...timeSlots];
    updated.find((d) => d.dayIndex === dayIndex).breaks[bIndex].label = value;
    setTimeSlots(updated);
  };

  const updateBreakTime = (dayIndex, bIndex, type, value) => {
    const updated = [...timeSlots];
    updated.find((d) => d.dayIndex === dayIndex).breaks[bIndex][type] = value;
    setTimeSlots(updated);
  };

  const removeBreak = (dayIndex, bIndex) => {
    const updated = [...timeSlots];
    updated.find((d) => d.dayIndex === dayIndex).breaks.splice(bIndex, 1);
    setTimeSlots(updated);
  };

  const generateTimeOptions = () => {
    const options = [];
    const start = 7 * 60; // 7:00 AM in minutes
    const end = 21 * 60; // 9:00 PM in minutes

    for (let mins = start; mins <= end; mins += 30) {
      const hours = Math.floor(mins / 60);
      const minutes = mins % 60;
      const ampm = hours >= 12 ? "PM" : "AM";
      const hour12 = hours % 12 || 12;
      const label = `${hour12.toString().padStart(2, "0")}:${minutes
        .toString()
        .padStart(2, "0")} ${ampm}`;
      const value = `${hours.toString().padStart(2, "0")}:${minutes
        .toString()
        .padStart(2, "0")}`;
      options.push({ label, value });
    }

    return options;
  };

  const TimeInput = ({ value, onChange }) => {
    const options = generateTimeOptions();
    return (
      // <input
      //   type="time"
      //   value={value}
      //   onChange={(e) => onChange(e.target.value)}
      //   className="border border-border px-2 py-1 text-sm text-yellowdark rounded w-[120px] bg-dry"
      // />
      <select
        value={value}
        onChange={(e) => onChange(e.target.value)}
        className="border border-border px-2 py-1 text-sm text-yellowdark rounded w-[120px] bg-dry"
      >
        {options.map((opt) => (
          <option key={opt.value} value={opt.value}>
            {opt.label}
          </option>
        ))}
      </select>
    );
  };

  const convertTo24H = (timeStr) => {
    const [time, modifier] = timeStr.split(" ");
    let [hours, minutes] = time.split(":");
    if (modifier === "PM" && hours !== "12") hours = parseInt(hours, 10) + 12;
    if (modifier === "AM" && hours === "12") hours = "00";
    return `${hours.toString().padStart(2, "0")}:${minutes}`;
  };

  const convertTo12H = (timeStr) => {
    if (!timeStr) return "";
    let [hours, minutes] = timeStr.split(":");
    hours = parseInt(hours, 10);
    const ampm = hours >= 12 ? "PM" : "AM";
    hours = hours % 12 || 12;
    return `${hours.toString().padStart(2, "0")}:${minutes} ${ampm}`;
  };

  return (
    <div className="bg-dry p-4 border border-border rounded">
      <h3 className="text-text font-semibold mb-4">Weekly Schedule & Breaks</h3>

      <div className="grid grid-cols-1 md:grid-cols-1 xl:grid-cols-1 gap-6 text-text">
        {daysOfWeek.map((day, index) => {
          const isSelected = selectedDays.includes(index);
          const daySlot = timeSlots.find((t) => t.dayIndex === index);

          return (
            <div
              key={index}
              className="border border-border rounded p-4 shadow-sm"
            >
              <div className="flex justify-between items-center mb-3">
                <label className="flex items-center gap-2 font-medium">
                  <input
                    type="checkbox"
                    checked={isSelected}
                    onChange={() => toggleDay(index)}
                  />
                  {day}
                </label>
                {isSelected && (
                  <button
                    type="button" // 👈 prevent auto form submit
                    onClick={() => addBreak(index)}
                    className="text-sm text-yellowlight"
                  >
                    + break
                  </button>
                )}
              </div>

              {isSelected && (
                <>
                  {/* Working Hours */}
                  {daySlot && (
                    <div className="flex items-center gap-2 mb-3">
                      <span className="text-sm w-[100px]">Working hours</span>
                      <TimeInput
                        value={getHourFromSlot(daySlot?.slots?.[0]?.start)}
                        onChange={(val) =>
                          updateWorkingHour(
                            index,
                            "startHour",
                            parseInt(val.split(":")[0])
                          )
                        }
                      />
                      <span>to</span>
                      <TimeInput
                        value={getHourFromSlot(daySlot?.slots?.at(-1)?.end)}
                        onChange={(val) =>
                          updateWorkingHour(
                            index,
                            "endHour",
                            parseInt(val.split(":")[0])
                          )
                        }
                      />
                    </div>
                  )}

                  {/* Breaks */}
                  {(daySlot?.breaks || []).map((brk, bIndex) => (
                    <div key={bIndex} className="flex items-center gap-2 ml-6">
                      <input
                        type="text"
                        className="bg-dry px-1 w-[60px]"
                        value={brk.label || "Lunch"}
                        onChange={(e) =>
                          updateBreakLabel(index, bIndex, e.target.value)
                        }
                      />
                      <TimeInput
                        value={brk.start}
                        onChange={(val) =>
                          updateBreakTime(index, bIndex, "start", val)
                        }
                      />

                      {console.log(brk.start)}
                      <span>to</span>
                      <TimeInput
                        value={brk.end}
                        onChange={(val) =>
                          updateBreakTime(index, bIndex, "end", val)
                        }
                      />
                      <button
                        type="button" // 👈 prevent auto form submit
                        onClick={() => removeBreak(index, bIndex)}
                        className="text-red-500"
                      >
                        🗑️
                      </button>
                    </div>
                  ))}
                </>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
}
